import React, { Component, Fragment } from 'react'
import { Route } from 'react-router-dom'

import AuthenticatedRoute from '../AuthenticatedRoute/AuthenticatedRoute'
import AutoDismissAlert from '../AutoDismissAlert/AutoDismissAlert'
import Header from '../Header/Header'

// AUTH
import SignUp from '../SignUp/SignUp'
import SignIn from '../SignIn/SignIn'
import SignOut from '../SignOut/SignOut'
import ChangePassword from '../ChangePassword/ChangePassword'

// CHAT
import Messages from '../Message/Messages'
import CreateMessage from '../Message/Create/CreateMessage'
import EditMessage from '../Message/Edit/EditMessage'
// import DeleteMessage from '../Message/Delete/DeleteMessage'

class App extends Component {
  constructor () {
    super()

    this.state = {
      user: null,
      alerts: []
    }
  }

  setUser = user => this.setState({ user })

  clearUser = () => this.setState({ user: null })

  alert = ({ heading, message, variant }) => {
    this.setState({ alerts: [...this.state.alerts, { heading, message, variant }] })
  }

  render () {
    const { alerts, user } = this.state

    return (
      <Fragment>
        <Header user={user} />
        {alerts.map((alert, index) => (
          <AutoDismissAlert
            key={index}
            heading={alert.heading}
            variant={alert.variant}
            message={alert.message}
          />
        ))}
        <main className="container">
          <Route path='/sign-up' render={() => (
            <SignUp alert={this.alert} setUser={this.setUser}/>
          )} />
          <Route path='/sign-in' render={() => (
            <SignIn alert={this.alert} setUser={this.setUser}/>
          )} />
          <AuthenticatedRoute user={user} path='/sign-out' render={() => (
            <SignOut alert={this.alert} clearUser={this.clearUser} user={user}/>
          )} />
          <AuthenticatedRoute user={user} path='/change-password' render={() => (
            <ChangePassword alert={this.alert} user={user}/>
          )} />
          <Route exact path='/' render={() => (
            <Messages alert={this.alert} user={user}/>
          )} />
          <Route exact path='/' render={() => (
            (user && <CreateMessage alert={this.alert} user={user}/>)
          )} />
          <AuthenticatedRoute user={user} path='/messages/:id/edit' render={() => (
            <EditMessage alert={this.alert} user={user}/>
          )} />
        </main>
      </Fragment>
    )
  }
}

// <Sidebar/>
// <section id="main">
//   <MessagesList/>
//   <AddMessage/>
// </section>

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.js